"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_LOCALE = 'en-US';
var localeAliases = {
    // Standard language set (30 languages, MyAccount)
    'en-US': ['en'],
    'ar-SA': ['ar'],
    'bg-BG': ['bg'],
    'cs-CZ': ['cs'],
    'da-DK': ['da'],
    'de-DE': ['de'],
    'el-GR': ['el'],
    'es-ES': ['es'],
    'et-EE': ['et'],
    'fi-FI': ['fi'],
    'fr-FR': ['fr'],
    'he-IL': ['he'],
    'hi-IN': ['hi'],
    'hu-HU': ['hu'],
    'id-ID': ['id'],
    'it-IT': ['it'],
    'ja-JP': ['ja'],
    'ko-KR': ['ko'],
    'nb-NO': ['no'],
    'nl-NL': ['nl'],
    'pl-PL': ['pl'],
    'pt-BR': [],
    'pt-PT': ['pt'],
    'ro-RO': ['ro'],
    'ru-RU': ['ru'],
    'sv-SE': ['sv'],
    'tr-TR': ['tr'],
    'uk-UA': ['uk'],
    'zh-CN': ['zh', 'zh-cn', 'zh-Hans'],
    'zh-TW': ['zh-tw', 'zh-Hant'],
    // Extended language set
    'ca-ES': ['ca'],
    'en-GB': [],
    'es-MX': [],
    'es-US': [],
    'hr-HR': ['hr'],
    'lt-LT': ['lt'],
    'lv-LV': ['lv'],
    'ms-MY': ['ms'],
    'sk-SK': ['sk'],
    'sl-SI': ['sl'],
    'th-TH': ['th'],
    'vi-VN': ['vi'],
    'sr-Latn-RS': ['sr', 'sr-Latn'],
};
exports.normalizeLocale = function (languageOrLocale) {
    if (languageOrLocale === void 0) { languageOrLocale = DEFAULT_LOCALE; }
    if (localeAliases.hasOwnProperty(languageOrLocale)) {
        return languageOrLocale;
    }
    for (var locale in localeAliases) {
        if (localeAliases[locale].indexOf(languageOrLocale) > -1) {
            return locale;
        }
    }
    return DEFAULT_LOCALE;
};
//# sourceMappingURL=normalizeLocale.js.map